<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>绩效分配</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.object_type_code">
                <vDropdown
                    model_key="object_type_code"
                    model_name="请选择对象类型"
                    :model_value_default="queryParams['object_type_code']"
                    select_value="value"
                    request_uri="dropdownAssignmentObjectType"
                    @onDropChange="onDropChange"
                    ref="object_type_code_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.object_rid">
                <el-input
                    v-model="queryParams.object_rid"
                    placeholder="请输入对象RID"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.object_number">
                <el-input
                    v-model="queryParams.object_number"
                    placeholder="请输入对象单号(如有)"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.date_range">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.performance_unit_name"
                    placeholder="请输入绩效单元名称"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <!-- <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ is_all: true, type_code: [11, 15, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div> -->
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" :loading="btnLoading">新增</el-button>
                <el-button size="small" plain @click="toAssignment()" :loading="btnLoading">批量分配</el-button>
                <el-button size="small" plain @click="toFlush(1)" :loading="btnLoading">批量重算</el-button>
                <el-button size="small" plain @click="toFlush(2)" :loading="btnLoading">全量重算</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <crm-upload obj="performance_assignment" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="performance_assignment"
                @header-dragend="changeColWidth"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['rid', 'object_account_name', 'object_partner_name', 'object_product_name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onDelete, onReSize, onSearch, in_array } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import crmUpload from '@/components/common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect,
        crmUpload
    },
    name: 'performanceAssignmentComponent',
    data() {
        return {
            draggable: {
                data_name: 'performance_assignment'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            selected: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.object_type_code = this.postList.params.object_type_code || '';
                this.queryParams.object_rid = this.postList.params.object_rid || '';
                this.queryParams.object_number = '';
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        handleSelectionChange(val) {
            this.selected = [];
            val.forEach((element) => {
                this.selected.push(element['rid']);
            });
            return true;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['rid']) && row.rid) {
                this.$router.push({
                    path: '/performanceAssignmentDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (in_array(prop, ['object_partner_name']) && row.object_partner_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.object_partner_rid
                    }
                });
            } else if (in_array(prop, ['object_product_name']) && row.object_product_rid) {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.object_product_rid
                    }
                });
            } else if (in_array(prop, ['object_account_name']) && row.object_account_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.object_account_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                object_type_code:
                    this.postList.params && this.postList.params.object_type_code ? this.postList.params.object_type_code : '',
                object_rid: this.postList.params && this.postList.params.object_rid ? this.postList.params.object_rid : ''
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('performance_assignment_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('performance_assignment_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('performance_assignment', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).performance_assignment;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'performanceAssignmentLists');
        },
        //新增
        insert() {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'insert',
                    object_type_code:
                        this.postList.params && this.postList.params.object_type_code ? this.postList.params.object_type_code : '',
                    object_rid: this.postList.params && this.postList.params.object_rid ? this.postList.params.object_rid : ''
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'performanceAssignmentDelete', row.bill_number);
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        toAssignment() {
            if (this.selected.length < 1) {
                this.$message.error('请至少选择一行');
                return false;
            }
            this.$router.push({
                path: 'performanceAssignmentLineList',
                query: {
                    type: 'insert',
                    id: this.selected.join(',')
                }
            });
        },
        toFlush(type) {
            // 1-批量刷新 2-全量刷新
            if (type == 1) {
                // 批量刷新
                if (this.selected.length < 1) {
                    this.$message.error('请至少选择一行');
                    return false;
                }
                var params = {
                    performance_assignment_rids: this.selected
                };
            } else {
                var params = {};
            }

            this.btnLoading = true;
            this.$api['performanceAssignmentFlush'](params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '操作成功！',
                            type: 'success'
                        });
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            // this.$refs.performance_unit_code_ref.reset();
            // this.$refs.product_rid_ref.reset();

            if (this.postList.object_type_code) {
                this.$refs.object_type_code_ref.reset();
            }

            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>